import React from 'react';
import { withStyles } from "@material-ui/core";

const styles = theme => ({
    titleWrapper: {
        margin: '0 0 -0.5rem 0',
        paddingLeft: '0',
        paddingTop: '8px',
        fontSize: '1.7rem',
        display: 'flex'
    },
    title: {
        fontSize: '1.7rem',
        margin: '0 0 0.5rem 0',
        paddingTop: '8px',
        paddingLeft: '0'
    },
    circleIcon: {
        display: 'inline-block',
        borderRadius: '24px',
        boxShadow: '0px 0px 6px #E6EDF5',
        padding: '0.5em 0.6em',
        marginRight: '12px',
        height: '48px',
        width: '48px',
        textAlign: 'center',
        color: '#0A54A2',
        fontSize: '20px',
        border: '1px #E6EDF5',
        backgroundColor: '#FFFFFF'
    }
})

const SettingTitle = (props) => {
    let { classes, titleClass, titleText, icon } = props;

    return (<div className={classes.titleWrapper}>
        <React.Fragment>
            {icon ? <div className={classes.circleIcon}>{icon}</div> : ''}
            <h2 className={[classes.title, titleClass].join(' ')}>{titleText}</h2>
        </React.Fragment>
    </div>)
};

export default withStyles(styles)(SettingTitle);
